const __WEBPACK_NAMESPACE_OBJECT__ = SharedDependencies.MobXReact['application-83abc821'];